import "./ResultsWidget.css";
import React from "react";
import * as utils from "common/utils";

const AnalysisResultsWidget = ({ farm, analysis, perHaOnly, showNCE, noPrint, hideVersion }) => {
    let latestResults = analysis.currentResults;
    if (!latestResults) {
        latestResults = {
            nitrogenOverview: {
                farmLossPerHa: analysis.nLossPerHa,
            },
            phosphorusOverview: {
                farmLossPerHa: analysis.pLossPerHa,
            },
        };
        if (analysis.ghgkPerHa > 0) {
            latestResults.ghgResults = {
                total: analysis.ghgkPerHa,
            };
        }
    }
    if (analysis.class === "Budget") {
        const { offlineBudgets = [] } = farm;
        const offlineBudget = offlineBudgets.find((b) => b.id === analysis.id);
        if (!offlineBudget || offlineBudget.isDirty) {
            latestResults = {};
        }
    }

    const nPerHa = latestResults.nitrogenOverview && latestResults.nitrogenOverview.farmLossPerHa >= 0 && latestResults.nitrogenOverview.farmLossPerHa.toLocaleString();
    const nTotal = latestResults.nitrogenOverview && latestResults.nitrogenOverview.farmTotalLoss >= 0 && latestResults.nitrogenOverview.farmTotalLoss.toLocaleString();
    const pPerHa = latestResults.phosphorusOverview && latestResults.phosphorusOverview.farmLossPerHa >= 0 && latestResults.phosphorusOverview.farmLossPerHa.toLocaleString();
    const pTotal = latestResults.phosphorusOverview && latestResults.phosphorusOverview.farmTotalLoss >= 0 && latestResults.phosphorusOverview.farmTotalLoss.toLocaleString();
    const ghgPerHa = latestResults.ghgResults && latestResults.ghgResults.total >= 0 && latestResults.ghgResults.total.toLocaleString();
    const ghgTotal = latestResults.ghgResults && latestResults.ghgResults.total >= 0 && latestResults.ghgResults.reportingArea > 0 && utils.round((latestResults.ghgResults.total * latestResults.ghgResults.reportingArea) / 1000, 1).toLocaleString();
    const nce = showNCE && latestResults.nce >= 0 && latestResults.nce.toLocaleString();
    const modelVersion = !hideVersion && analysis.modelVersion;

    return (
        <div className={`results-widget ${noPrint ? "u-print-none" : ""}`}>
            <div className="results-widget__nutrient results-widget__nutrient--n">
                <div className="results-widget__name">N</div>
                <div className="results-widget__item">
                    <span className="results-widget__value" id={`${analysis.id}-nLost-ha`}>
                        {nPerHa || "-"}
                    </span>
                    {nPerHa && <span className="results-widget__uom">kg/ha</span>}
                </div>
                {!perHaOnly && nTotal && (
                    <>
                        <div className="results-widget__divider">|</div>
                        <div className="results-widget__item">
                            <span className="results-widget__value" id={`${analysis.id}-nLost`}>
                                {nTotal}
                            </span>
                            <span className="results-widget__uom">kg</span>
                        </div>
                    </>
                )}
            </div>
            <div className="results-widget__nutrient results-widget__nutrient--p">
                <div className="results-widget__name">P</div>
                <div className="results-widget__item">
                    <span className="results-widget__value" id={`${analysis.id}-pLost-ha`}>
                        {pPerHa || "-"}
                    </span>
                    {pPerHa && <span className="results-widget__uom">kg/ha</span>}
                </div>
                {!perHaOnly && pTotal && (
                    <>
                        <div className="results-widget__divider">|</div>
                        <div className="results-widget__item">
                            <span className="results-widget__value" id={`${analysis.id}-pLost`}>
                                {pTotal}
                            </span>
                            <span className="results-widget__uom">kg</span>
                        </div>
                    </>
                )}
            </div>
            <div className="results-widget__nutrient results-widget__nutrient--ghg">
                <div className="results-widget__name">GHG</div>
                <div className="results-widget__item">
                    <span className="results-widget__value" id={`${analysis.id}-ghg-ha`}>
                        {ghgPerHa || "-"}
                    </span>
                    {ghgPerHa && <span className="results-widget__uom">kg/ha</span>}
                </div>
                {!perHaOnly && ghgTotal && (
                    <>
                        <div className="results-widget__divider">|</div>
                        <div className="results-widget__item">
                            <span className="results-widget__value" id={`${analysis.id}-ghg`}>
                                {ghgTotal}
                            </span>
                            <span className="results-widget__uom">tonnes</span>
                        </div>
                    </>
                )}
            </div>
            {nce && (
                <div className="NCEIndicator" data-complete="75" style={{ marginLeft: 0, paddingLeft: 0 }}>
                    <span className="">NCE: </span>
                    <div className="is-neutral">
                        <svg className="NCEIndicator-path" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 35 35">
                            <circle cx="17.5" cy="17.5" r="16" fill="none" stroke="#cccccc" strokeWidth="3" strokeMiterlimit="0" />
                        </svg>
                        <span id={`${analysis.id}-nce`}>{nce}</span>
                    </div>
                </div>
            )}
            {modelVersion && (
                <div className="results-widget__version" id={`${analysis.id}-ver`}>
                    v{modelVersion}
                </div>
            )}
        </div>
    );
};

export default AnalysisResultsWidget;
